import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import AgentManager from './pages/AgentManager'
import PromptManager from './pages/PromptManager'
import KnowledgeBase from './pages/KnowledgeBase'
import ModelGateway from './pages/ModelGateway'
import TaskExecutor from './pages/TaskExecutor'
import ReviewLibrary from './pages/ReviewLibrary'
import ListingWorkbench from './pages/ListingWorkbench'
import AdsWorkbench from './pages/AdsWorkbench'
import VisualWorkbench from './pages/VisualWorkbench'
import QAWorkbench from './pages/QAWorkbench'

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/agents" element={<AgentManager />} />
        <Route path="/prompts" element={<PromptManager />} />
        <Route path="/knowledge" element={<KnowledgeBase />} />
        <Route path="/models" element={<ModelGateway />} />
        <Route path="/tasks" element={<TaskExecutor />} />
        <Route path="/reviews" element={<ReviewLibrary />} />
        <Route path="/workbench/listing" element={<ListingWorkbench />} />
        <Route path="/workbench/ads" element={<AdsWorkbench />} />
        <Route path="/workbench/visual" element={<VisualWorkbench />} />
        <Route path="/workbench/qa" element={<QAWorkbench />} />
      </Routes>
    </Layout>
  )
}

export default App
